module.exports = __webpack_public_path__ + "media/images/lalamove-rider-c4b3090b4da7dabc715cc324c3c1ecce.jpg";